/**
 * Centralized design tokens — charts, tooltips, and JS-driven styles.
 * Import from here; do not hardcode chart hex in components.
 */

export const CHART_RAMP = ['#234A3C', '#4E7A6A', '#7BA194', '#A9C3BA', '#D8CFBE'];

export const CHART_NEUTRALS = {
  hairline: '#E0D9CA',
  ink: '#211D16',
  inkMuted: '#8C8473',
  inkFaint: '#B3AB9C',
  bone: '#F3EFE6',
  boneRaised: '#FBF8F1',
};

export const CHART_AXIS = {
  grid: { strokeDasharray: '3 3', stroke: CHART_NEUTRALS.hairline },
  axisLine: { stroke: CHART_NEUTRALS.hairline },
  tick: {
    fill: CHART_NEUTRALS.inkMuted,
    fontSize: 11,
    fontFamily: '"Hanken Grotesk", system-ui, sans-serif',
  },
  tickFigure: {
    fill: CHART_NEUTRALS.inkMuted,
    fontSize: 11,
    fontFamily: '"Fraunces Variable", Georgia, serif',
  },
  legend: {
    fontFamily: '"Hanken Grotesk", system-ui, sans-serif',
    fontSize: 12,
    color: CHART_NEUTRALS.inkMuted,
  },
};

export const CHART_TOOLTIP_STYLE = {
  background: CHART_NEUTRALS.boneRaised,
  border: `1px solid ${CHART_NEUTRALS.hairline}`,
  borderRadius: 6,
  color: CHART_NEUTRALS.ink,
  fontSize: 13,
  fontFamily: '"Hanken Grotesk", system-ui, sans-serif',
};

export const CHART_TOOLTIP_LABEL_STYLE = {
  color: CHART_NEUTRALS.ink,
  fontFamily: '"Hanken Grotesk", system-ui, sans-serif',
};

export const SANKEY_NODE = {
  fill: CHART_RAMP[0],
  stroke: CHART_NEUTRALS.hairline,
  strokeWidth: 1,
};

export const SANKEY_LINK = {
  stroke: CHART_RAMP[1],
  strokeOpacity: 0.45,
};

/** Pick a categorical color from the tonal pine ramp. */
export const chartColor = (index) => CHART_RAMP[Math.abs(index) % CHART_RAMP.length];
